import { loadLovBatch } from '@zoryn/hooks'
import { buildColumnInfo, collectLovTypes } from '@zoryn/components/grid/src/column/meta'
import { isFilterableColumn } from '@zoryn/components/grid/src/filter/filter-utils'
import { captureColumnBaseline } from '@zoryn/components/grid/src/methods/custom'
import { normalizeGridTreeColumnProps } from './column/seq-column'
import type { DataGridTree, GridColumnProps, GridColumnInfo } from './types'
import type { LovConfigContext } from '@zoryn/hooks'

export function createLoadColumns(
  $grid: DataGridTree,
  getLovConfig: () => LovConfigContext | undefined
) {
  return async (columns: GridColumnProps[]) => {
    const normalized = normalizeGridTreeColumnProps(columns)
    const list: GridColumnInfo[] = []
    normalized.forEach((col, index) => {
      const info = buildColumnInfo(col, index)
      if (info) list.push(info)
    })
    $grid.internalData.allColumns = list
    $grid.internalData.visibleColumns = list.filter((col) => col.visible !== false)
    $grid.internalData.titleList = $grid.internalData.visibleColumns.filter(isFilterableColumn)
    captureColumnBaseline($grid as never)

    const lovTypes = collectLovTypes(normalized)
    if (lovTypes.length) {
      const lovConfig = getLovConfig()
      await loadLovBatch(lovTypes, {
        fetchBatch: lovConfig?.fetchLovBatch,
        fetchLov: lovConfig?.fetchLov,
        cacheTtl: lovConfig?.cacheTtl,
      })
    }
    $grid.updateFooter?.()
  }
}
